import { Feld } from './feld.enum';

export class FeldBeschreibung {
    public id: Feld;
    public title: string;
    public hilfetext?: string;
    public orderNum: number;
}
